<script>
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";
import _ from "lodash";
import Vue from "vue";

export default {
  name: "AdminPanel",
  data: () => ({}),
  mounted() {
    // this.GetAllCountStatements();
    // this.GetListStatementsOnFaculty();
    // this.GetListStatementsOnHostel();
  },
  computed: {
    ...mapState({
      all_count_statements: state => state.adminPanelStmHostel.all_count_statements,
      list_statements_on_faculty: state => state.adminPanelStmHostel.list_statements_on_faculty,
      list_statements_on_hostel: state => state.adminPanelStmHostel.list_statements_on_hostel,
      status_sync_stm_hostels: state => state.adminPanelStmHostel.status_sync_stm_hostels,
      status_sync_hostel_orders: state => state.adminPanelStmHostel.status_sync_hostel_orders,
      resp_message: state => state.adminPanelStmHostel.resp_message,
    }),
    ...mapGetters({}),
    message_for_sync_stm_hostels() {
      return this.resp_message?.data?.message
    },
    status_message_for_sync_stm_hostels() {
      return " | " + this.resp_message?.data?.processed_count + " | " + this.resp_message?.data?.success_count + " / " + this.resp_message?.data?.error_count
    },
    message_for_sync_hostel_orders() {
      return this.resp_message?.data?.message
    },
    status_message_for_sync_hostel_orders() {
      return this.resp_message?.status
    },
    data_request(){
      return this.resp_message
    }
  },
  methods: {
    ...mapMutations({}),
    ...mapActions({
      GetAllCountStatements: 'adminPanelStmHostel/GetAllCountStatements',
      GetListStatementsOnFaculty: 'adminPanelStmHostel/GetListStatementsOnFaculty',
      GetListStatementsOnHostel: 'adminPanelStmHostel/GetListStatementsOnHostel',
      GetSyncStatementHostels: 'adminPanelStmHostel/GetSyncStatementHostels',
      GetSyncHostelOrders: 'adminPanelStmHostel/GetSyncHostelOrders',
    }),

  }
}
</script>

<template>
  <v-app>
    <v-main>
      <v-container fluid>
        <v-card outlined max-height="800px" rounded="xl">
          <v-card-title>
            <h6 class="text-sm-h4 text-h6 mx-auto">
              Статистика заявлений
            </h6>
          </v-card-title>
        </v-card>
        <v-row class="mt-2">
          <v-col cols="12">
            <v-card outlined max-height="800px" rounded="xl">
              <v-card-text>
                <table class="text-subtitle-1">
                  <tr>
                    <td class="pe-4">Общее кол-во заявлений:</td>
                    <td>{{ all_count_statements.all_statements_count }}</td>
                  </tr>
                  <tr>
                    <td class="pe-4">Рассматирваемых заявлений:</td>
                    <td>{{ all_count_statements.consid_statements_count }}</td>
                  </tr>
                  <tr>
                    <td class="pe-4">Отклоненные заявления:</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td class="pe-4">Принятые заявления:</td>
                    <td>{{ all_count_statements.conf_statements_count }}</td>
                  </tr>
                  <tr v-for="(el_hostel) in list_statements_on_hostel" :key="el_hostel.id">
                    <td class="pe-4">{{ el_hostel.name_hostel }}:</td>
                    <td>{{ el_hostel.count }}</td>
                  </tr>
                </table>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="6">
            <v-card
                outlined
                height="100%"
                rounded="xl"
            >
              <v-card-title>
                Синхронизации
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12">
                    <v-btn
                        :loading="status_sync_stm_hostels"
                        :disabled="status_sync_stm_hostels"
                        @click="GetSyncStatementHostels"
                        class="white--text"
                        rounded
                        color="teal"
                    >
                      Синхронизировать текущих проживающих
                    </v-btn>
                    <p>
                      {{ message_for_sync_stm_hostels }} : {{ status_message_for_sync_stm_hostels }}
                    </p>
                  </v-col>
                  <v-col cols="12">
                    <v-btn
                        :loading="status_sync_hostel_orders"
                        :disabled="status_sync_hostel_orders"
                        @click="GetSyncHostelOrders"
                        class="white--text"
                        rounded
                        color="teal"
                    >
                      Синхронизировать актуальные приказы
                    </v-btn>
                    <p>
                      {{ message_for_sync_hostel_orders }} / {{ status_message_for_sync_hostel_orders }}
                    </p>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="6">
            <v-card
                class="rounded-xl"
                outlined
                height="100%"
            >
              <v-card-title>
                Результат синхронизации
              </v-card-title>
              <v-card-text>
                <v-textarea
                    class="rounded-xl"
                    :value="data_request"
                    readonly
                    auto-grow
                    outlined
                    label="Ответ"
                >
                </v-textarea>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
<!--        <v-row class="mt-2">-->
<!--          <v-col cols="4" v-for="(faculty, index) in list_statements_on_faculty" :key="index">-->
<!--            <v-card outlined rounded="xl">-->
<!--              <v-card-title>-->
<!--                {{ faculty.name }}-->
<!--              </v-card-title>-->
<!--              <v-card-text>-->
<!--                <div>-->
<!--                  <span>Количество заявлений:</span>-->
<!--                  <span class="text-h6">{{ faculty.count }}</span>-->
<!--                </div>-->
<!--              </v-card-text>-->
<!--            </v-card>-->
<!--          </v-col>-->
<!--        </v-row>-->
      </v-container>
    </v-main>
  </v-app>
</template>

<style scoped>

</style>